<template>
  <div class="container">
    <div class="row">
      <div class="med-bg navbar">
        <div :class="org">
          <b-navbar toggleable="md" class="navbar navbar-dark navbar-expand-md med-bg navbar-sticky">
            <b-navbar-toggle target="navbar-collapse"></b-navbar-toggle>
            <b-collapse id="navbar-collapse" is-nav>
              <b-navbar-nav>
                <b-nav-item class="arrow_box" v-bind:class="{ active: $route.path.includes('/information') }"
                  :to="{ name: 'information',
                  params: { organization_name: $route.params.organization_name,
                    scholarship_name: $route.params.scholarship_name }}">
                  INFORMATION
                </b-nav-item>
                <b-nav-item class="arrow_box" v-bind:class="{ active: $route.path.includes('/requirements') }"
                  :to="{ name: 'requirements',
                  params: { organization_name: $route.params.organization_name,
                    scholarship_name: $route.params.scholarship_name }}">
                  REQUIREMENTS
                </b-nav-item>
                <div v-if="active.false != false">
                  <b-nav-item class="arrow_box" v-bind:class="{ active: $route.path.includes('/apply') }"
                    :to="{ name: 'apply',
                    params: { organization_name: $route.params.organization_name,
                      scholarship_name: $route.params.scholarship_name }}">
                    APPLICATION
                  </b-nav-item>
                </div>
                <div v-else>
                <b-nav-item class="arrow_box" disabled>
                  APPLICATION
                </b-nav-item>
                </div>
                <b-nav-item class="arrow_box" v-bind:class="{ active: $route.path.includes('/review'),
                  'no-hover': $route.path.includes('/information') || $route.path.includes('/requirements'),
                  'disabled': $route.path.includes('/information') || $route.path.includes('/requirements')}"
                  :to="{ name: 'review',
                  params: { organization_name: $route.params.organization_name,
                    scholarship_name: $route.params.scholarship_name }}">
                  REVIEW & SUBMIT
                </b-nav-item>
              </b-navbar-nav>
            </b-collapse>
          </b-navbar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
 import axios from '../auth'

export default {
  props: {
    active: Object
  },
  components:{
  },
  data(){
    return {
      loggedIn: "false",
      org: this.$route.params.organization_name
    }
  },
  mounted(){
    this.$store.watch( (state, getters) => {
      this.loggedIn = getters.loginStatus
    })
  },
  methods:{
    submitSubmission() {
      axios.post(
        `${process.env.VUE_APP_ENDPOINT}/api/applicant/${this.$route.params.organization_name}/${this.$route.params.scholarship_name}/submit/`,
        {}
      ).then( () => {
        this.$toasted.success('The application has been successfully submitted!',
          {
            position: "bottom-right",
            duration : 10000
          })
          this.$router.push({name: "status",
            params: { organization_name: this.$route.params.organization_name,
                      scholarship_name: this.$route.params.scholarship_name}})
      }).catch(err => {
        if(err.response.data.message === "The application has already been submitted.") {
          this.$router.push({name: "status",
            params: { organization_name: this.$route.params.organization_name,
                      scholarship_name: this.$route.params.scholarship_name}})
        } else {
          this.$router.push({name: "apply",
            params: { organization_name: this.$route.params.organization_name,
                      scholarship_name: this.$route.params.scholarship_name}})
        }
        this.$toasted.error(
            err.response.data.message,
          {
            theme: "outline",
            position: "bottom-right",
            duration : 10000
          })
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
